import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { mergePDFs } from '../utils/pdfUtils';
import { saveAs } from 'file-saver';
import './ToolPage.css';

const PDFMerge = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [processedFile, setProcessedFile] = useState(null);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFile(null);
    };

    const handleMerge = async () => {
        if (files.length < 2) {
            alert('Please select at least two PDF files');
            return;
        }

        setProcessing(true);

        try {
            const mergedPdf = await mergePDFs(files);
            setProcessedFile(mergedPdf);
        } catch (error) {
            alert('Merge failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const handleDownload = () => {
        if (processedFile) {
            saveAs(processedFile, processedFile.name);
        }
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>📑 PDF Merge</h1>
                <p>Merge multiple PDF files into one file</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="application/pdf"
                    onFilesSelected={handleFilesSelected}
                    title="Upload PDF Files"
                    description="Select multiple PDF files to merge"
                />

                {files.length > 0 && !processing && !processedFile && (
                    <div className="tool-controls">
                        <p className="info-text">{files.length} file(s) selected, will be merged in order</p>
                        <button className="btn btn-primary" onClick={handleMerge}>
                            Merge PDF
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Merging PDFs..." />}

                {processedFile && (
                    <div className="results">
                        <h3>Merge Complete!</h3>
                        <p>Merged {files.length} PDF file(s)</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            Download Merged PDF
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PDFMerge;
